import React, { useState } from "react";
import { useFormikContext } from "formik";
import { FormattedMessage } from "react-intl";
import { Space, Button, Row } from "@masterteam/mt-design-react";

import Table from "../../NewTable";
import ValuesForm from "../ValuesForm";
import useIsAr from "../../../Hooks/useIsAr";

import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete.svg";
import AsyncSvg from "../../AsyncSvg";
import AsyncImg from "../../AsyncImg";

const initialModalState = {
  isOpen: false,
  data: null,
};

const Values = ({ data }) => {
  const [isAr, locale] = useIsAr();
  const { values, setFieldValue } = useFormikContext();
  const [valueModal, setValueModal] = useState(initialModalState);

  const columns = [
    {
      key: "arabic-name",
      header: <FormattedMessage id="strategy.arabic-value" />,
      cell: (item) => item?.ArabicName,
      width: "20%",
    },
    {
      key: "english-name",
      header: <FormattedMessage id="strategy.english-value" />,
      cell: (item) => item.EnglishName,
      width: "20%",
    },
    {
      key: "icon",
      header: <FormattedMessage id="common.icon" />,
      cell: (item) =>
        item?.Attachment ? (
          item?.Attachment?.preview ? (
            <img
              width={25}
              height={25}
              src={item?.Attachment?.preview}
              name={item?.Attachment.FileName}
              alt={item?.Attachment.FileName}
            />
          ) : (
            <AsyncImg file={item?.Attachment} width={25} height={25} />
          )
        ) : (
          "---"
        ),
      width: "20%",
    },
    {
      key: "order",
      header: <FormattedMessage id="common.order" />,
      cell: (item) => item.Order || "---",
      width: "20%",
    },
    {
      key: "action",
      header: <FormattedMessage id="common.action" />,
      cell: (item) => (
        <Space gap={4}>
          <Button
            variant="success"
            shape="square"
            fill="none"
            Icon={EditIcon}
            onClick={(e) => {
              e.stopPropagation();
              setValueModal({
                isOpen: true,
                data: item,
              });
            }}
          />
          <Button
            variant="error"
            shape="square"
            fill="none"
            Icon={DeleteIcon}
            onClick={(e) => {
              e.stopPropagation();
              let newData = [...values.Values];
              newData = newData.filter((el) => el.index !== item?.index);
              setFieldValue("Values", newData);
            }}
          />
        </Space>
      ),
      width: "10%",
    },
  ];

  return (
    <Space size="small" direction="vertical">
      <Row align="center" justify="between" className="values-title">
        <FormattedMessage id="strategy.values" />

        <Button
          onClick={() => {
            setValueModal({ isOpen: true, data: null });
          }}
        >
          <FormattedMessage id="common.add" />
        </Button>
      </Row>

      <Table
        data={values?.Values || []}
        columns={columns}
        compact
        headerStyle={{ fontWeight: "normal" }}
      />

      {valueModal.isOpen && (
        <ValuesForm
          data={valueModal.data}
          closeModal={() => setValueModal(initialModalState)}
        />
      )}
    </Space>
  );
};

export default Values;
